import { compose, dissoc, assoc, prop, map, when, equals, always } from 'ramda'
import dashDefinitions from './index'
import {
  RHD_43N_38N_CODE,
  DASH_CODE_SEPARATOR,
  DASH_TYPE_Q_BUS_DATABOOK_CODE,
  DASH_TYPE_Q_RV_DATABOOK_CODE,
  DASH_TYPE_Q_AUPPN_DATABOOK_CODES,
  DIGITAL_DASH_CODE,
  DIGITAL_DASH_LOCATION_ID,
  ICU,
  ICUC5,
} from './dashConstants'

// Resolve the vehicle's panel and navigation layout together (XR7719 incident).
export const resolveDashDefinition = ({
  dashboardType,
  vehicleSubType,
  vehicleType,
  dataBookCodes,
  isPreProduction,
}) => {
  if (!dashboardType) return null

  const dbCodes = dataBookCodes || []

  const isRightHandDriveVehicle = dbCodes.includes(RHD_43N_38N_CODE)
  const isAfterMarket42nBus =
    dbCodes.includes(DASH_TYPE_Q_BUS_DATABOOK_CODE) &&
    dashboardType === 'Q' &&
    isPreProduction === false

  const is42nRv =
    dbCodes.includes(DASH_TYPE_Q_RV_DATABOOK_CODE) &&
    dashboardType === 'Q' &&
    isPreProduction === false

  let definitionKey = isAfterMarket42nBus
    ? '001-310_42N_BUS'
    : is42nRv
    ? '001-343_42N_RV'
    : dashboardType

  if (
    vehicleSubType === '42N' &&
    dashboardType === 'Q' &&
    isPreProduction === false &&
    vehicleType === 'CHECP'
  ) {
    if (
      DASH_TYPE_Q_AUPPN_DATABOOK_CODES.some((code) => dbCodes.includes(code))
    ) {
      definitionKey = 'CHECPLUS_42N_Q_734_025'
    } else if (dbCodes.includes(DASH_TYPE_Q_BUS_DATABOOK_CODE)) {
      definitionKey = 'CHECP_42N_BUS_SCHOOL'
    } else {
      definitionKey = 'CHECP_42N_BUS'
    }
  }

  let definition = isRightHandDriveVehicle
    ? dashDefinitions[
        `${RHD_43N_38N_CODE}${DASH_CODE_SEPARATOR}${vehicleSubType}`
      ]
    : dashDefinitions[definitionKey]

  if (!definition) return null

  if (dbCodes.includes(DIGITAL_DASH_CODE)) {
    const panels = prop('panels', definition)
    const replaceIcuWithDigitalIcu = (dashPanels) =>
      map(when(equals(ICU), always(ICUC5)), dashPanels)
    const digitalDashPanels = replaceIcuWithDigitalIcu(panels)
    // XR7719 incident: navigation must follow the digital panel substitution.
    definition = assoc('panels', digitalDashPanels, dissoc(ICU, definition))
    if (definition.navOrder) {
      definition = assoc(
        'navOrder',
        replaceIcuWithDigitalIcu(definition.navOrder),
        definition
      )
    }
  } else {
    definition = compose(
      dissoc(DIGITAL_DASH_LOCATION_ID),
      dissoc(ICUC5)
    )(definition)
  }

  return definition
}
